module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"matrix-tagil":"Корреспонденции"},"en":{"matrix-tagil":"Correspondence"}}')
  delete Component.options._Ctor
}
